import { Tab as ReactTab } from 'react-tabs';
import styled, { css } from 'styled-components';
export const TabContainer = styled(ReactTab) ``;
export const Tab = styled.button `
  position: relative;
  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
  cursor: pointer;

  &:hover,
  &:focus {
    color: var(--text-brand);
    outline: none;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
    height: 2px;
    background: var(--text-primary);
    opacity: 0;
  }

  ${({ $variant }) => $variant === 'dimmed' &&
    css `
      color: var(--text-secondary);
    `};

  ${({ $variant }) => $variant === 'scrollable' &&
    css `
      color: var(--text-secondary);
      white-space: nowrap;
      font-weight: var(--font-weight-semibold);
    `};

  ${({ $isActive }) => $isActive &&
    css `
      color: var(--text-primary) !important;

      &:after {
        opacity: 1;
      }
    `};
`;
